<template>
  <div id="NewPresentation">
      <SendSurvey/>
  </div>
</template>

<script>
import SendSurvey from '../../components/sendSurvey/SendSurvey.vue';


export default {
  name: "NewPresentation",
  components: {
    SendSurvey
  },
};
</script>